import React from "react";

import InfoSvg from "../../../components/LandingTypography/assets/info.svg";

const Info = ({ size = 10, style }) => {
  return (
    <img src={InfoSvg} alt={""} width={size} height={size} style={style} />
  );
};

export default Info;
